import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordSocialLoginFormCmsKey = 'FacebookLogin' | 'DividerOr';

export const ForgotPasswordSocialLoginFormCmsWithDefault: CmsObjectWithDefault<ForgotPasswordSocialLoginFormCmsKey> = {
    FacebookLogin: {
        cmsId: 78131,
        defaultTranslation:
            "Have trouble remembering your Agoda password? Login with Facebook now and you'll never have to",
    },
    DividerOr: {
        cmsId: 63536,
        defaultTranslation: 'or',
    },
};
